/** English (default) — nested keys for i18next (`t('header.title')`). */
export const en = {
  header: {
    brandAlt: 'Avatar',
    /** `{{name}}` from GET /v1/config.name (falls back to brandAlt). */
    title: 'Chat with {{name}}',
    subtitle: 'Ask, discover, or get help instantly',
    reset: 'Reset conversation',
  },
  chat: {
    typing: 'Avatar is typing…',
    errorFallback:
      "Sorry about this. I'm unable to assist with your request right now due to a temporary issue on our side. Please try again shortly.",
    networkError: 'Network error. Please check your connection and try again.',
    widgetDisabled:
      'This chat is no longer available. New messages cannot be sent right now.',
    rateLimited: "You're sending messages too quickly. Please wait a moment and try again.",
    originNotAllowlisted:
      "This chat isn't available on this website yet. Please contact the website owner.",
    bundleNotAllowlisted:
      "This chat isn't available in this app yet. Please contact the app provider.",
    identifyDisabled: 'Identity verification is disabled for this avatar.',
    identifyRequired:
      "We couldn't confirm your sign-in. Please sign in, then open the chat again.",
    retry: 'Try again',
    streamingPlaceholder: '…',
    newConversationStarted: 'New conversation started',
    yesterday: 'Yesterday',
  },
  input: {
    placeholder: 'Ask anything...',
    ariaLabel: 'Message Avatar',
    send: 'Send message',
    attach: 'Attach file',
    attachments: 'Attached files',
    removeAttachment: 'Remove file {{index}}',
    retryUpload: 'Retry upload of {{name}}',
    uploading: 'Uploading {{percent}}%',
    uploadFailed: 'Upload failed. Tap to retry.',
    pickPhotos: 'Photo Library',
    pickFiles: 'Choose File',
    pickCancel: 'Cancel',
    poweredBy: 'Powered by Avatar.inc',
  },
  popular: {
    ariaLabel: 'Suggested questions',
  },
  /** File attachment errors (BR-05 / BR-17). */
  attachment: {
    typeNotAllowed:
      "{{name}} can't be attached. Only JPG, PNG, WEBP and PDF files are allowed.",
    tooLarge: '{{name}} is larger than 10 MB and can\'t be attached.',
    limit: 'You can attach up to 5 files per message.',
    rateLimited: 'Too many uploads. Please wait a while and try again.',
    disabled: 'File upload is turned off for this chat.',
    uploadFailed: "{{name}} couldn't be uploaded. Tap it to try again.",
    sendInvalid:
      "Your files couldn't be sent. Please attach them again.",
    sendTypeNotAllowed:
      "One of your files isn't a valid JPG, PNG, WEBP or PDF, or the image is too large. Please remove it and try again.",
    sendTooLarge: 'One of your files is larger than 10 MB. Please remove it and try again.',
    unavailable: "Files can't be sent right now. Please try again shortly.",
    sessionExpired:
      'Your chat session ended before sending, so the files expired. Please attach them again.',
  },
  mobile: {
    subtitle: 'Your AI assistant for {{name}}.',
    hello: "Hello, I'm {{name}}",
    heroBody:
      'I can help you discover, create, and get the most out of your {{name}}.',
    heroHint: 'Select a question below or type a message.',
    heroHintVoice:
      'Select a question below or tap the microphone to ask by voice.',
    popularHeading: 'Popular Questions',
    placeholder: 'Ask {{name}}...',
    back: 'Close',
    mic: 'Voice input',
  },
  doc: {
    title: 'Avatar Widget',
  },
} as const;

/** Same tree as `en`, but values are plain strings (other locales). */
export type EnTranslation = {
  [K in keyof typeof en]: {
    [P in keyof (typeof en)[K]]: string;
  };
};
